<template>
  <div :class="['Game', { active: isGameActive } ]" @click="mobileGameButtonTap">
    <div class="content">
      <Video :onStart="startGamePlay" :onHit="increaseScore" :onMiss="decreaseScore" :game="game" :keyframes="gameKeyframes" :onGameComplete="proceed" :toggleGameActiveState="toggleGameActiveState" :gameLength="gameLength" ref="Video"/>
      <!-- <Feedback v-if="showFeedback" :feedbackType="feedbackType" :onAnimationComplete="hideFeedback" /> -->
      <Feedback :feedbackType="feedbackType" :onAnimationComplete="hideFeedback" ref="feedback"/>

    </div>
  </div>
</template>

<script>

import { CONFIG } from '@/config'
import { gamePlayAudio } from '@/audio'

import Video from '@/components/Video.vue'
import Feedback from '@/components/Feedback.vue'

import { TweenLite } from 'gsap'

export default {
  name: 'Game',
  props: {
    onComplete: Function,
  },
  components: {
    Video,
    Feedback
  },
  data() {
    return {
      showFeedback: false,
      feedbackType: 0, // positive or negative
      isGameActive: false,
      timeout: null
    }
  },
  watch: {
    windowState( state ) {
     ( state == 'blur' ) ? gamePlayAudio.pause() : gamePlayAudio.play()
    },
  },
  mounted() {
  },
  beforeDestroy() {
    gamePlayAudio.stop()

    clearTimeout( this.timeout )
  },
  computed: {
    game() { return this.$store.state.game },
    gameLength() { return CONFIG.videoData[this.game].length },
    preCountdownTarget() { return CONFIG.videoData[this.game].preCountdownTarget },
    gameKeyframes() { return CONFIG.videoData[this.game].keyframes },
    isMobile() { return this.$store.state.isMobile },
    windowState() { return this.$store.state.windowState },
  },
  methods: {
    mobileGameButtonTap() {
      if ( this.isMobile ) this.$refs.Video.onTrigger()
    },
    toggleGameActiveState() {
      this.isGameActive = !this.isGameActive
    },
    startGamePlay() {
      this.$refs.Video.playVideo()

      gamePlayAudio.play()
      gamePlayAudio.seek( 38 - ( this.gameLength + this.preCountdownTarget ) )
      gamePlayAudio.fade( gamePlayAudio.volume(), 0.3, 500 )
    },
    proceed() {
      this.gsr = 0

      // set transition first then push route
      this.$store.commit( 'setBackgroundVideoState', { isBackgroundVideoPlaying: true } )
      this.$store.commit( 'setTransitionVisibility', { isTransitionVisible: true } )

      gamePlayAudio.fade( gamePlayAudio.volume(), 0.0, 500 )

      this.timeout = setTimeout( () => {

        gamePlayAudio.stop()
        this.onComplete()

      }, 500)

    },
    increaseScore() {
      if ( !this.isGameActive ) return // Only track during actual game play

      this.$store.commit( 'setScore', { game: this.game, score: this.$store.state.scores[this.game] + 1 } )

      this.showFeedback = true
      this.feedbackType = 1


      this.$refs.feedback.playAnimation()
    },
    decreaseScore() {

      if ( !this.isGameActive ) return // Only track during actual game play

      this.$store.commit( 'setScore', { game: this.game, score: this.$store.state.scores[this.game] - 1 } )

      this.showFeedback = true
      this.feedbackType = 0

      this.$refs.feedback.playAnimation()
    },
    hideFeedback() {
      this.showFeedback = false
    }
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .Game {

    padding-top: rem( 60 );

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    z-index: 1;

    height: 100%;

    &.active {

      @include breakpoint( mobile-all ) {

        z-index: 10;

      }

    }

    .content {

      height: 100%;
      width: 100%;

      display: flex;
      justify-content: center;
      align-items: center;

    }

  }

</style>
